import React, { Component } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Checkbox,
  Tabs,
  message,
  DatePicker,
  Space,
  Tooltip,
  Modal,
} from "antd";
import "./Form.css";
import "./AddAccount.css";
import { observer } from "mobx-react";
import JourneyPlannerStore from "../store/journeyplannerstore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import VehicleStore from "../store/VehicleStore";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { CheckLg } from "react-bootstrap-icons";
import { CloseOutlined } from "@ant-design/icons";
import Cookies from "universal-cookie";
import { decode as base64_decode } from "base-64";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

const { Option } = Select;
const { TabPane } = Tabs;
const dateFormat = "YYYY-MM-DD HH:mm:ss";

dayjs.extend(customParseFormat);

const toDayjs = (value) => {
  if (value == null || value === "") return null;
  if (dayjs.isDayjs(value)) return value.isValid() ? value : null;
  const parsed = dayjs(value, dateFormat, true);
  return parsed.isValid() ? parsed : dayjs(value).isValid() ? dayjs(value) : null;
};

// const RISK_MATRIX_ROWS = [
//   {
//     key: "noOfPeopleInVehicle",
//     label: "No Of People In Vehicle",
//     options: [
//       { label: "Driver Only", color: "#4caf50", score: 1 },
//       { label: "Driver with one passenger", color: "#ffc107", score: 2 },
//       {
//         label: "Driver With more than one passenger",
//         color: "#f44336",
//         score: 3,
//       },
//     ],
//   },
//   {
//     key: "driverExperience",
//     label: "Driver Experience",
//     options: [
//       { label: "More than 5 Yrs", color: "#4caf50", score: 1 },
//       { label: "1-5 Yrs", color: "#ffc107", score: 2 },
//       { label: "less than 1 yr", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "roadType",
//     label: "Road type",
//     options: [
//       { label: "Paved", color: "#4caf50", score: 1 },
//       { label: "Gravel (Resource Road)", color: "#ffc107", score: 2 },
//       { label: "Off Road (4x4 necessary)", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "weatherForecast",
//     label: "Weather Forecast",
//     options: [
//       { label: "Clear", color: "#4caf50", score: 1 },
//       { label: "Wet", color: "#ffc107", score: 2 },
//       { label: "Inclement", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "lightingVisibility",
//     label: "Lighting/ Visibility",
//     options: [
//       { label: "Day Light", color: "#4caf50", score: 1 },
//       { label: "Sun rise/ Sunset", color: "#ffc107", score: 2 },
//       { label: "Night/Dark", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "communications",
//     label: "Communications",
//     options: [
//       { label: "Monitored Tracking", color: "#4caf50", score: 1 },
//       {
//         label: "Reliable- 2 way radio or cell/ Sateline Phone",
//         color: "#ffc107",
//         score: 2,
//       },
//       { label: "Unreliable or none", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "trafficVolume",
//     label: "Traffic Volume",
//     options: [
//       { label: "Light", color: "#4caf50", score: 1 },
//       { label: "Moderate", color: "#ffc107", score: 2 },
//       { label: "Heavy", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "segmentDuration",
//     label: "Segment Duration",
//     options: [
//       { label: "Less Than 2 Hours", color: "#4caf50", score: 1 },
//       { label: "2-6 Hours", color: "#ffc107", score: 2 },
//       { label: "More than 6 hours", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "highRiskLocations",
//     label: "High Risk Locations",
//     options: [
//       { label: "None", color: "#4caf50", score: 1 },
//       { label: "Less Than five", color: "#ffc107", score: 2 },
//       { label: "five or More", color: "#f44336", score: 3 },
//     ],
//   },
//   {
//     key: "riskOfViolence",
//     label: "Risk of Violence",
//     options: [
//       { label: "Very Unlikely", color: "#4caf50", score: 1 },
//       { label: "Possible but unlikely", color: "#ffc107", score: 2 },
//       { label: "quite possble", color: "#f44336", score: 3 },
//     ],
//   },
// ];

const RISK_MATRIX_ROWS = [
  {
    key: "noOfPeopleInVehicle",
    labelKey: "_NO_OF_PEOPLE_IN_VEHICLE_",
    options: [
      { labelKey: "_DRIVER_ONLY_", color: "#4caf50", score: 1 },
      { labelKey: "_DRIVER_WITH_ONE_PASSENGER_", color: "#ffc107", score: 2 },
      { labelKey: "_DRIVER_WITH_MORE_THAN_ONE_PASSENGER_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "driverExperience",
    labelKey: "_DRIVER_EXPERIENCE_",
    options: [
      { labelKey: "_MORE_THAN_5_YRS_", color: "#4caf50", score: 1 },
      { labelKey: "_1_5_YRS_", color: "#ffc107", score: 2 },
      { labelKey: "_LESS_THAN_1_YR_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "roadType",
    labelKey: "_ROAD_TYPE_",
    options: [
      { labelKey: "_PAVED_", color: "#4caf50", score: 1 },
      { labelKey: "_GRAVEL_RESOURCE_ROAD_", color: "#ffc107", score: 2 },
      { labelKey: "_OFF_ROAD_4X4_NECESSARY_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "weatherForecast",
    labelKey: "_WEATHER_FORECAST_",
    options: [
      { labelKey: "_CLEAR_", color: "#4caf50", score: 1 },
      { labelKey: "_WET_", color: "#ffc107", score: 2 },
      { labelKey: "_INCLEMENT_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "lightingVisibility",
    labelKey: "_LIGHTING_VISIBILITY_",
    options: [
      { labelKey: "_DAY_LIGHT_", color: "#4caf50", score: 1 },
      { labelKey: "_SUN_RISE_SUNSET_", color: "#ffc107", score: 2 },
      { labelKey: "_NIGHT_DARK_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "communications",
    labelKey: "_COMMUNICATIONS_",
    options: [
      { labelKey: "_MONITORED_TRACKING_", color: "#4caf50", score: 1 },
      { labelKey: "_RELIABLE_2_WAY_RADIO_OR_CELL_SAT_PHONE_", color: "#ffc107", score: 2 },
      { labelKey: "_UNRELIABLE_OR_NONE_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "trafficVolume",
    labelKey: "_TRAFFIC_VOLUME_",
    options: [
      { labelKey: "_LIGHT_", color: "#4caf50", score: 1 },
      { labelKey: "_MODERATE_", color: "#ffc107", score: 2 },
      { labelKey: "_HEAVY_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "segmentDuration",
    labelKey: "_SEGMENT_DURATION_",
    options: [
      { labelKey: "_LESS_THAN_2_HOURS_", color: "#4caf50", score: 1 },
      { labelKey: "_2_6_HOURS_", color: "#ffc107", score: 2 },
      { labelKey: "_MORE_THAN_6_HOURS_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "highRiskLocations",
    labelKey: "_HIGH_RISK_LOCATIONS_",
    options: [
      { labelKey: "_NONE_", color: "#4caf50", score: 1 },
      { labelKey: "_LESS_THAN_FIVE_", color: "#ffc107", score: 2 },
      { labelKey: "_FIVE_OR_MORE_", color: "#f44336", score: 3 },
    ],
  },
  {
    key: "riskOfViolence",
    labelKey: "_RISK_OF_VIOLENCE_",
    options: [
      { labelKey: "_VERY_UNLIKELY_", color: "#4caf50", score: 1 },
      { labelKey: "_POSSIBLE_BUT_UNLIKELY_", color: "#ffc107", score: 2 },
      { labelKey: "_QUITE_POSSIBLE_", color: "#f44336", score: 3 },
    ],
  },
];
const getTranslatedRiskMatrixRows = (translate) =>
  RISK_MATRIX_ROWS.map((row) => ({
    ...row,
    label: translate ? translate(row.labelKey) : row.labelKey,
    options: row.options.map((opt) => ({
      ...opt,
      label: translate ? translate(opt.labelKey) : opt.labelKey,
    })),
}));
const parseRiskSelectorData = (record) => {
  if (!record) return {};
  let raw =
    record.riskSelectorData ??
    record.riskselectordata ??
    record.risk_selector_data;

  if (raw == null || raw === "") {
    const fromFields = {};
    RISK_MATRIX_ROWS.forEach((row) => {
      if (record[row.key] != null && record[row.key] !== "") {
        fromFields[row.key] = Number(record[row.key]);
      }
    });
    return fromFields;
  }

  if (typeof raw === "string") {
    try {
      raw = JSON.parse(raw);
    } catch {
      return {};
    }
  }

  if (Array.isArray(raw)) {
    return raw.reduce((acc, item) => {
      const key = item.fieldKey ?? item.key ?? item.rowKey;
      const score = item.score ?? item.value;
      if (key != null && score != null) acc[key] = Number(score);
      return acc;
    }, {});
  }

  if (typeof raw === "object") {
    return Object.entries(raw).reduce((acc, [key, score]) => {
      if (score != null && score !== "") acc[key] = Number(score);
      return acc;
    }, {});
  }

  return {};
};

// const buildRiskSelectorData = (riskSelections) =>
//   RISK_MATRIX_ROWS.map((row) => {
//     const score = riskSelections[row.key];
//     const option = row.options.find((o) => o.score === score);
//     return {
//       key: row.key,
//       label: row.label,
//       score: score ?? null,
//       selectedLabel: option?.label ?? "",
//     };
//   }).filter((item) => item.score != null);
const buildRiskSelectorData = (riskSelections, translate) =>
  getTranslatedRiskMatrixRows(translate).map((row) => {
    const score = riskSelections[row.key];
    const option = row.options.find((o) => o.score === score);
    return {
      key: row.key,
      label: row.label,
      score: score ?? null,
      selectedLabel: option?.label ?? "",
    };
  }).filter((item) => item.score != null);

class JourneyPlannerAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      companyId: "",
      journeyId: -1,
      journeyNum: " ",
      loadingSpin: false,
      travelType: "",
      activeTab: "1",
      riskSelections: {},
      riskScore: 0,
      managers: [],
      desks: [],
      approvalAction: null,
      vehiclesList: [],
      isAlreadyApproved: false,
      isAlreadyRejected: false,
      initialVehicleId: null,
      selectedVehicleId: null,
      isApprovedFromSafety: 0,
      safetyManagerName: "",
      safetyRejectionReason: "",
      reasonForRejection: "",
      safetyManagersList: [],
      staffList: [],
      showApprovalAlert: false,
      extendedCount:0,
      extendedDateTime:"",
      extendedDateTime2:"",
      extendedDateTime3:""

    };
    this.journeyPlannerStore = new JourneyPlannerStore();
    this.companyStore = new CompanyStore(this);
    this.vehicleStore = new VehicleStore();

    this.cookies = new Cookies();
    let cookies = this.cookies.get("data");
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      this.fetchDesksAndManagers(this.props.getUserData().userCompanyId);
      this.fetchVehicles(this.props.getUserData().userCompanyId);
    }
    const { journeyId, journeyNum } = this.props;
    this.setState({ journeyNum })
    if (journeyId) {
      this.filldata(journeyId);
      this.setState({ journeyId });

    }
    let tokendata = this.cookies.get("data")
      ? JSON.parse(base64_decode(this.cookies.get("data")))
      : "";
    console.log("tokendata", tokendata)
    console.log(tokendata.emailId, "tokendata")
    console.log(tokendata.mobileno, "tokendata01")
    console.log(tokendata.name, "token data02")
    this.formRef.current?.setFieldsValue({
      applicantEmailId: tokendata.emailId,
      applicantContactNo: tokendata.mobileno,
      applicantName: tokendata.name,
    });


    // this.setState({loadData:1})
    // this.setState({ staffList: staffList })
  }

  async filldata(journeyId) {
    await this.setState({ loadingSpin: true });
    const data = await this.journeyPlannerStore.getJourneyData(journeyId);
    if (!data) return;
    console.log("data", data)
    await this.setState({ companyId: data.companyId ,extendedCount:data.extendedCount,extendedDateTime:data.extendedDateTime,extendedDateTime2:data.extendedDateTime2,extendedDateTime3:data.extendedDateTime2});
    console.log("this is the state data",this.state.extendedCount)
    await this.fetchDesksAndManagers(data.companyId);
    await this.fetchVehicles(data.companyId);
    const singleData = await this.companyStore.getCompanyDataById(
      data.companyId,
    );
    this.formRef.current.setFieldsValue({
      companyId: singleData,
      applicantName: data.applicantName,
      applicantEmailId: data.applicantEmailId,
      alternateApplicants: data.staff,
      keepApplicantsPostedCheckbox: data.staffCheckbox,
      applicantContactNo: data.applicantContactNo,
      journeyDesk: data.journeyDesk,
      journeyManager: data.journeyManager,
      travelType: data.travelType,
      purpose: data.purpose,
      travelersName: data.travelersName,
      startLocation: data.startLocation,
      destination: data.destination,
      destinationPartyName: data.destinationPartyName,
      destinationContact: data.destinationContact,
      proposedTravelDate: toDayjs(data.proposedTravelDate),
      expectedArrivalDate: toDayjs(data.expectedArrivalDate),
      checkInContactNo: data.checkInContactNo,
      communicationMethod: data.communicationMethod,
      route: data.route,
      riskScore: data.riskScore,
      proposedStartTime: toDayjs(data.proposedStartTime),
      proposedEndTime: toDayjs(data.proposedEndTime),
      coPassengers: data.coPassengers,
      vehicleId: data.vehicleId,
      rejectionReason: data.rejectionReason || data.reasonForRejection || "",
      reasonForRejection: data.reasonForRejection || data.rejectionReason || "",
      safetyRejectionReason: data.safetyManagerRejectionReason || data.safetyRejectionReason || "",
      safetyIncharge: Number(data.safetyIncharge) || null,
      requestReturnDate: data.requestReturnDate
      ? dayjs(data.requestReturnDate).format("YYYY-MM-DD HH:mm:ss")
      : "",
      extendedDateTime1: data?.extendedDateTime
      ? dayjs(data.extendedDateTime)
      : null,

      extendedDateTime2: data?.extendedDateTime2
        ? dayjs(data.extendedDateTime2)
        : null,

      extendedDateTime3: data?.extendedDateTime3
        ? dayjs(data.extendedDateTime3)
        : null,
    });
    const riskSelections = parseRiskSelectorData(data);
    const riskScoreFromSelections = Object.values(riskSelections).reduce(
      (sum, v) => sum + v,
      0,
    );
    const riskScore =
      data.riskScore != null && data.riskScore !== ""
        ? Number(data.riskScore)
        : riskScoreFromSelections;

    const isApprovedFromSafety = data.isApprovedFromSafety != null ? Number(data.isApprovedFromSafety) : 0;
    const safetyManagerName = data.safetyInchargeName || "";
    const safetyRejectionReason = data.safetyManagerRejectionReason || data.safetyRejectionReason || "";
    const reasonForRejection = data.reasonForRejection || data.rejectionReason || "";

    let approvalAction = data.vehicleId ? "accept" : (data.rejectionReason || data.reasonForRejection) ? "reject" : null;
    const currentUserAdmin = Number(this.props.getUserData().isadmin);
    if (currentUserAdmin === 7) {
      if (isApprovedFromSafety === 1) {
        approvalAction = "accept";
      } else if (isApprovedFromSafety === 2) {
        approvalAction = "reject";
      }
    }

    const isAlreadyApproved = !!data.vehicleId || isApprovedFromSafety === 1;
    const isAlreadyRejected = !!data.rejectionReason || !!data.reasonForRejection || Number(data.status) === 4;

    await this.setState({
      travelType: data.travelType,
      riskSelections,
      riskScore,
      loadingSpin: false,
      approvalAction,
      isAlreadyApproved,
      isAlreadyRejected,
      initialVehicleId: data.vehicleId || null,
      selectedVehicleId: data.vehicleId || null,
      isApprovedFromSafety,
      safetyManagerName,
      safetyRejectionReason,
      reasonForRejection,
      safetyIncharge: Number(data.safetyIncharge) || null,
    });
    this.formRef.current?.setFieldsValue({ riskScore });
  }

  handleChange = async (comp) => {
    await this.setState({ companyId: comp.value });
    this.fetchDesksAndManagers(comp.value);
    this.fetchVehicles(comp.value);
  };

  fetchDesksAndManagers = async (companyId) => {
    console.log("companyId//////", companyId);
    if (!companyId) return;
    try {
      const [desks, managers] = await Promise.all([
        this.journeyPlannerStore.getjourneyDesk(),
        this.journeyPlannerStore.getJourneyManager(companyId),
        // this.journeyPlannerStore.getSafetyManagers(companyId),
      ]);
      this.setState({ desks, managers });
      // console.log("this.journeyPlannerStore.safetymanagerlist", await this.journeyPlannerStore.safetymanagerlist);
    } catch (error) {
      console.error("Error fetching desks and managers:", error);
    }
  };

  fetchVehicles = async (companyId) => {
    if (!companyId) return;
    try {
      const vehicles = await this.journeyPlannerStore.getVehicles(companyId);
      this.setState({ vehiclesList: vehicles || [] });
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }
  };

  isEditMode = () => {
    const id = this.props.journeyId ?? this.state.journeyId;
    return id != null && id !== "" && id !== -1;
  };

  handleRiskSelect = (rowKey, score) => {
    if (this.isEditMode()) return;
    const updated = { ...this.state.riskSelections, [rowKey]: score };
    const total = Object.values(updated).reduce((sum, v) => sum + v, 0);
    this.setState({ riskSelections: updated, riskScore: total });
    this.formRef.current.setFieldsValue({ riskScore: total });
  };

  handleTabChange = (key) => {
    this.setState({ activeTab: key });
  };

  handleNextClick = async () => {
    try {
      if (this.state.activeTab === "1") {
        const fieldsToValidate = [
          "applicantEmailId",
          "applicantContactNo",
          "journeyDesk",
          "journeyManager",
          "travelType",
        ];
        if (
          Number(this.props.getUserData().isadmin) === -1 ||
          Number(this.props.getUserData().isadmin) === 3
        ) {
          fieldsToValidate.push("companyId");
        }
        if (this.state.travelType === "Outside Project") {
          fieldsToValidate.push(
            "startLocation",
            "destination",
            "proposedTravelDate",
            "expectedArrivalDate"
          );
        }
        if (this.state.riskScore >= 24) {
          fieldsToValidate.push("safetyIncharge");
        }
        await this.formRef.current.validateFields(fieldsToValidate);
      }
      const next = String(Number(this.state.activeTab) + 1);
      this.setState({ activeTab: next });
    } catch (err) {
      console.error("Validation error:", err);
      message.error("Please fill all required fields.");
    }
  };

  handleBackClick = () => {
    const prev = String(Number(this.state.activeTab) - 1);
    this.setState({ activeTab: prev });
  };

  onSubmit = async (fieldsValue) => {
    this.setState({ loadingSpin: true });
    if (
      !this.isEditMode() &&
      this.state.travelType === "Outside Project" &&
      RISK_MATRIX_ROWS.some((r) => !this.state.riskSelections[r.key])
    ) {
      this.setState({ activeTab: "2", loadingSpin: false });
      message.error("Please complete all Risk Matrix fields.");
      return;
    }

    const currentUserAdmin = Number(this.props.getUserData().isadmin);
    const isSafetyApprovalPending = currentUserAdmin === 6 && this.state.riskScore >= 24 && (this.state.isApprovedFromSafety === 0 || this.state.isApprovedFromSafety == null);
    const isAdmin7AlreadyActed = currentUserAdmin === 7 && (Number(this.state.isApprovedFromSafety) === 1 || Number(this.state.isApprovedFromSafety) === 2);

    if (
      !isSafetyApprovalPending &&
      !isAdmin7AlreadyActed &&
      (currentUserAdmin === 6 || (currentUserAdmin === 7 && this.state.riskScore >= 24)) &&
      !this.state.approvalAction
    ) {
      this.setState({ loadingSpin: false, showApprovalAlert: true });
      return;
    }

    const isOutsideProject = this.state.travelType === "Outside Project";
    const data = {
      ...fieldsValue,
      proposedStartTime: toDayjs(fieldsValue.proposedStartTime)?.format(
        dateFormat
      ),
      proposedEndTime: toDayjs(fieldsValue.proposedEndTime)?.format(dateFormat),
      Id: this.state.journeyId,
      journeyNum: this.state.journeyNum,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      staffCheckbox: fieldsValue.keepApplicantsPostedCheckbox ? 1 : 0,
      staff:fieldsValue.alternateApplicants,
      riskScore: this.state.riskScore,
      // riskSelectorData: isOutsideProject
      //   ? buildRiskSelectorData(this.state.riskSelections)
      //   : [],
      riskSelectorData: isOutsideProject
      ? buildRiskSelectorData(this.state.riskSelections, this.context.translate)
      : [],
      safetyIncharge: this.state.riskScore >= 24 ? fieldsValue.safetyIncharge || null : null,
      journeyDeskName: fieldsValue.journeyDesk.label,
      journeyDesk:fieldsValue.journeyDesk.value,
      startLocation: fieldsValue.startLocation?.value,
      startLocationName: fieldsValue.startLocation?.label,
    };

    console.log("data01236", data);

    let tokendata = this.cookies.get("data")
      ? JSON.parse(base64_decode(this.cookies.get("data")))
      : "";
    const currentUserName = tokendata ? tokendata.userName || tokendata.name || "" : "";

    if (currentUserAdmin === 6) {
      if (this.state.approvalAction === "accept") {
        data.isApprovedFromSafety = 1;
      } else if (this.state.approvalAction === "reject") {
        data.isApprovedFromSafety = 0;
        data.status = 4;
        data.reasonForRejection = fieldsValue.reasonForRejection || fieldsValue.rejectionReason;
        data.rejectionReason = data.reasonForRejection;
      }
    }

    if (currentUserAdmin === 7 && this.state.riskScore >= 24) {
      if (this.state.approvalAction === "accept") {
        data.isApprovedFromSafety = 1;
        data.safetyManagerName = currentUserName;
      } else if (this.state.approvalAction === "reject") {
        data.isApprovedFromSafety = 2;
        data.safetyManagerName = currentUserName;
        data.safetyManagerRejectionReason = fieldsValue.safetyRejectionReason || fieldsValue.safetyManagerRejectionReason;
        data.safetyRejectionReason = data.safetyManagerRejectionReason;
        data.status = 4;
      }
    }

    // Preserve existing reasons if not updated by this action
    if (!data.safetyManagerRejectionReason) {
      data.safetyManagerRejectionReason = this.state.safetyRejectionReason;
      data.safetyRejectionReason = this.state.safetyRejectionReason;
    }
    if (!data.reasonForRejection) {
      data.reasonForRejection = this.state.reasonForRejection;
      data.rejectionReason = this.state.reasonForRejection;
    }

    console.log("data>>>>>>>>>>>", data);
    const resp = await this.journeyPlannerStore.addData(data);
    await this.props.response(resp);
    this.setState({ loadingSpin: false });
  };

  closeModal = () => {
    this.props.closeModal();
  };

  showTabTitle = () => {
    const { activeTab, travelType } = this.state;
    if (activeTab === "1") return this.context.translate("_JOURNEY_DETAILS_");
    if (activeTab === "2" && travelType === "Outside Project")
      return this.context.translate("_RISK_MATRIX_");;
    return this.context.translate("_JOURNEY_DETAILS_");;
  };

  showTabDesc = () => {
    const { activeTab, travelType } = this.state;
    if (activeTab === "1") return  this.context.translate("_FILL_IN_THE_JOURNEY_INFORMATION_BELOW_");;
    if (activeTab === "2" && travelType === "Outside Project") {
      return this.isEditMode()
        ? this.context.translate("_RISK_MATRIX_CANNOT_BE_CHANGED_WHEN_EDITING_")
        : this.context.translate("_SELECT_ONE_OPTION_PER_ROW_");
    }
    return "";
  };

  disablePastDate = (current) => {
    return current && current < dayjs().startOf("day");
  };

  disablePastTime = () => {
    const now = dayjs();

    return {
      disabledHours: () =>
        Array.from({ length: now.hour() }, (_, i) => i),

      disabledMinutes: (selectedHour) =>
        selectedHour === now.hour()
          ? Array.from({ length: now.minute() }, (_, i) => i)
          : [],
    };
  };
  isReadOnly = () => {
    const adminType = this.props.getUserData().isadmin;
    return (adminType === 6 || adminType === 7 || adminType === 1) && this.props.journeyId;
  };

  // Banner shown at top of form for isadmin 6 when safety manager has responded
  renderSafetyBanner() {
    const currentUserAdmin = Number(this.props.getUserData().isadmin);
    const { riskScore, isApprovedFromSafety, safetyManagerName } = this.state;

    if (currentUserAdmin !== 6 || riskScore < 24) return null;

    if (Number(isApprovedFromSafety) === 1) {
      return (
        <div style={{
          background: "#f6ffed",
          border: "1px solid #b7eb8f",
          borderRadius: "8px",
          padding: "12px 16px",
          color: "#52c41a",
          fontWeight: "500",
          fontSize: "14px",
          marginBottom: "16px",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          width: "100%",
        }}>
          <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", background: "#52c41a", flexShrink: 0 }} />
            {this.context.translate("_ACCEPTED_BY_SAFETY_MANAGER")}:{" "} {safetyManagerName || "Safety Manager"}
        </div>
      );
    }

    if (Number(isApprovedFromSafety) === 2) {
      return (
        <div style={{
          background: "#fff2f0",
          border: "1px solid #ffccc7",
          borderRadius: "8px",
          padding: "12px 16px",
          color: "#ff4d4f",
          fontWeight: "500",
          fontSize: "14px",
          marginBottom: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          width: "100%",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: "600" }}>
            <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", background: "#ff4d4f", flexShrink: 0 }} />
             {this.context.translate("_REJECTED_BY_SAFETY_MANAGER")}:{" "} {safetyManagerName || "Safety Manager"}
          </div>
          {this.state.safetyRejectionReason && (
            <div style={{ color: "#595959", fontSize: "13px", paddingLeft: "16px" }}>
              <strong>{this.context.translate("_REJECTION_REASON")}:</strong>{" "} {this.state.safetyRejectionReason}
            </div>
          )}
        </div>
      );
    }

    if (Number(isApprovedFromSafety) === 0 || isApprovedFromSafety == null) {
      return (
        <div style={{
          background: "#fffbe6",
          border: "1px solid #ffe58f",
          borderRadius: "8px",
          padding: "12px 16px",
          color: "#ad6800",
          fontWeight: "500",
          fontSize: "14px",
          marginBottom: "16px",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          width: "100%",
        }}>
          <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", background: "#faad14", flexShrink: 0 }} />
           {this.context.translate("_NO_RESPONSE_FROM_SAFETY_MANAGER")}
        </div>
      );
    }

    return null;
  }

  renderApprovalSection() {
    const currentUserAdmin = Number(this.props.getUserData().isadmin);
    const { riskScore, isApprovedFromSafety, safetyManagerName, approvalAction, isAlreadyApproved, isAlreadyRejected } = this.state;

    if (currentUserAdmin !== 6 && !(currentUserAdmin === 7 && riskScore >= 24)) {
      return null;
    }

    // ── isadmin 6 ──────────────────────────────────────────────────────────────
    if (currentUserAdmin === 6) {
      const safetyAccepted  = Number(isApprovedFromSafety) === 1;
      const safetyRejected  = Number(isApprovedFromSafety) === 2;
      const safetyPending   = !safetyAccepted && !safetyRejected;

      // When riskScore >= 24 and safety manager has NOT yet responded → both buttons disabled
      if (riskScore >= 24 && safetyPending) {
        return (
          <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
            <Space>
              <Button disabled> {this.context.translate("_ACCEPT_")}</Button>
              <Button disabled> {this.context.translate("_REJECT_")}</Button>
            </Space>
          </div>
        );
      }

      // When safety manager REJECTED → only Reject button (disabled, informational)
      if (riskScore >= 24 && safetyRejected) {
        return (
          <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
            <Space>
              <Button disabled>{this.context.translate("_ACCEPT_")}</Button>
              <Button disabled type="primary" danger>{this.context.translate("_REJECT_")}</Button>
            </Space>
          </div>
        );
      }

      // riskScore < 24 OR (riskScore >= 24 && safety manager ACCEPTED)
      // → show both Accept and Reject buttons
      const vehicleSelectJsx = approvalAction === "accept" && (
        <>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="vehicleId"
                className="uploadCompany"
                label={<span> {this.context.translate("_SELECT_VEHICLE_")}<span style={{ color: "red" }}>*</span>:</span>}
                rules={[{ required: true, message: this.context.translate("_SELECT_VEHICLE_REQUIRED_"), }]}
              >
                <Select
                  placeholder="Select Vehicle"
                  onChange={(value) => this.setState({ selectedVehicleId: value })}
                >
                  {this.state.vehiclesList?.map((v) => (
                    <Option key={v.vehicleId} value={v.vehicleId} disabled={v.color === "#c27171"}>
                      <Tooltip title={v.color === "#c27171" ? this.context.translate("_VEHICLE_ALREADY_ASSIGNED_") : ""}>
                        <span>{v.vehicleNo}</span>
                      </Tooltip>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          {isAlreadyApproved && this.state.selectedVehicleId && this.state.selectedVehicleId !== this.state.initialVehicleId && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="reasonForChangeVehicle"
                  className="uploadCompany"
                  label={<span>   {this.context.translate("_REASON_FOR_CHANGING_VEHICLE_")}<span style={{ color: "red" }}>*</span>:</span>}
                  rules={[{ required: true,  message: this.context.translate("_REASON_FOR_CHANGING_VEHICLE_REQUIRED_"), }]}
                >
                  <Input.TextArea rows={2}  placeholder={this.context.translate("_ENTER_REASON_FOR_CHANGING_VEHICLE_")} />
                </Form.Item>
              </Col>
            </Row>
          )}
        </>
      );

      const rejectionJsx = approvalAction === "reject" && (
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="reasonForRejection"
              className="uploadCompany"
              label={<span> {this.context.translate("_REASON_FOR_REJECTION_")}<span style={{ color: "red" }}>*</span>:</span>}
              rules={[{ required: true, message: this.context.translate("_WRITE_REJECTION_REASON_"),}]}
            >
              <Input.TextArea rows={3} placeholder={this.context.translate("_ENTER_REJECTION_REASON_")} />
            </Form.Item>
          </Col>
        </Row>
      );

      return (
        <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
          <div style={{ marginBottom: "20px" }}>
            <Space>
              {/* Accept — disabled when already rejected */}
              <Button
                type={approvalAction === "accept" ? "primary" : "default"}
                style={{
                  backgroundColor: approvalAction === "accept" ? "#52c41a" : undefined,
                  borderColor: approvalAction === "accept" ? "#52c41a" : undefined,
                  color: approvalAction === "accept" ? "#fff" : undefined,
                }}
                disabled={approvalAction === "reject"}
                onClick={() => this.setState({ approvalAction: "accept" })}
              >
                Accept
              </Button>
              {/* Reject — disabled when already accepted */}
              <Button
                type={approvalAction === "reject" ? "primary" : "default"}
                danger={approvalAction === "reject"}
                disabled={approvalAction === "accept"}
                onClick={() => this.setState({ approvalAction: "reject" })}
              >
                Reject
              </Button>
            </Space>
          </div>
          {vehicleSelectJsx}
          {rejectionJsx}
        </div>
      );
    }

    // ── isadmin 7 (Safety Manager) ─────────────────────────────────────────────
    if (currentUserAdmin === 7 && riskScore >= 24) {
      const isAccepted = Number(isApprovedFromSafety) === 1;
      const isRejected = Number(isApprovedFromSafety) === 2;

      return (
        <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
          <div style={{ marginBottom: "20px" }}>
            <Space>
              {/* Accept — disabled when already rejected OR already accepted */}
              <Button
                type={approvalAction === "accept" ? "primary" : "default"}
                style={{
                  backgroundColor: approvalAction === "accept" ? "#52c41a" : undefined,
                  borderColor: approvalAction === "accept" ? "#52c41a" : undefined,
                  color: approvalAction === "accept" ? "#fff" : undefined,
                }}
                disabled={isRejected || isAccepted}
                onClick={() => !isAccepted && !isRejected && this.setState({ approvalAction: "accept" })}
              >
                Accept
              </Button>
              {/* Reject — disabled when already accepted OR already rejected */}
              <Button
                type={approvalAction === "reject" ? "primary" : "default"}
                danger={approvalAction === "reject"}
                disabled={isAccepted || isRejected}
                onClick={() => !isAccepted && !isRejected && this.setState({ approvalAction: "reject" })}
              >
                Reject
              </Button>
            </Space>
          </div>

          {/* Show rejection reason textarea only when actively selecting reject (not yet saved) */}
          {approvalAction === "reject" && !isRejected && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="safetyRejectionReason"
                  className="uploadCompany"
                  label={<span> {this.context.translate("_REASON_FOR_REJECTION_")}<span style={{ color: "red" }}>*</span>:</span>}
                  rules={[{ required: true,  message: this.props.context.translate("_WRITE_REJECTION_REASON_")}]}
                >
                  <Input.TextArea rows={3}   placeholder={this.context.translate("_ENTER_REJECTION_REASON_")} />
                </Form.Item>
              </Col>
            </Row>
          )}

          {/* Show readonly rejection reason after already rejected */}
          {isRejected && this.state.safetyRejectionReason && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="safetyRejectionReason"
                  className="uploadCompany"
                  label={
                  this.context.translate("_REASON_FOR_REJECTION_") + ":"
                }
                >
                  <Input.TextArea
                    rows={3}
                    readOnly
                    style={{ backgroundColor: "#f5f5f5", color: "#000" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
        </div>
      );
    }

    return null;
  }

  renderTab1() {
    const { travelType } = this.state;
    return (
      <div
        style={{
          overflowY: "scroll",
          height: "90%",
          paddingInlineStart: "20px",
        }}
      >
        {this.renderSafetyBanner()}
        <Row gutter={16}>
          <Col span={12}>
            {(this.props.getUserData().isadmin === -1 ||
              this.props.getUserData().isadmin === 3) && (
                <Form.Item
                  name="companyId"
                  className="uploadCompany"
                  label={
                    <span>
                      {this.context.translate("_ACCOUNT_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate("_ACCOUNT_")} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <CompanyAutocomplete
                    onChange={this.handleChange}
                    style={{ width: "100%" }}
                    companyId={this.state.companyId}
                  />
                </Form.Item>
              )}

            <Form.Item
              name="applicantName"
              className="uploadCompany"
               label={this.context.translate("_APPLICANT_NAME_") + ":"}
            >
              <Input placeholder={this.context.translate("_APPLICANT_NAME_")} readOnly />
            </Form.Item>

            <Form.Item
              name="applicantEmailId"
              className="uploadCompany"
              label={
                <span>
                  {this.context.translate("_APPLICANT_EMAIL_ID_")}<span style={{ color: "red" }}>*</span>:
                </span>
              }
              required={false}
              rules={[
                {
                  type: "email",
                  required: true,
                 message: this.context.translate("_APPLICANT_EMAIL_REQUIRED_"),
                },
              ]}
            >
              <Input readOnly />
            </Form.Item>
            <Form.Item
              name="alternateApplicants"
              className="select-dropdown"
              label={this.context.translate("_ALTERNATE_APPLICANTS_") + ":"}
               style={{ marginBottom: 23 }}
            >
              <Select  placeholder={this.context.translate("_SELECT_ALTERNATE_APPLICANT_")}  mode="multiple" disabled={this.isReadOnly()}>
                {this.journeyPlannerStore.stafflist.map((d) => {
                  const value = d.id ?? d.deskId ?? d.value;
                  const label = d.name ?? d.deskName ?? d.label;
                  return (
                    <Option key={value} value={value}>
                      {label}
                    </Option>
                  );
                })}

              </Select>
            </Form.Item>

            <Form.Item
              name="keepApplicantsPostedCheckbox"
              label={this.context.translate("_KEEP_APPLICANTS_POSTED_") + ":"}
              valuePropName="checked"
              className="journeypost"
            >
              <Checkbox disabled={this.isReadOnly()} />
            </Form.Item>
            

            {travelType === "Outside Project" && (
              <>
                <Form.Item
                  name="travellerName"
                  className="uploadCompany"
                 label={this.context.translate("_TRAVELLERS_NAME_OTHER_THAN_APPLICANT_") + ":"}
                >
                  <Input readOnly={this.isReadOnly()} />
                </Form.Item>

                <Form.Item
                  name="startLocation"
                  className="uploadCompany"
                  label={
                    <span>
                      {this.context.translate("_START_LOCATION_")}<span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                  required={false}
                  rules={[
                    { required: true,   message: this.context.translate("_START_LOCATION_REQUIRED_"), },
                  ]}
                >
                  <Select placeholder={this.context.translate("_SELECT_START_LOCATION_")} disabled={this.isReadOnly()} labelInValue>
                    {this.state.desks.map((d) => {
                      const value = d.id ?? d.deskId ?? d.value;
                      const label = d.name ?? d.deskName ?? d.label;
                      return (
                        <Option key={value} value={value}>
                          {label}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="destination"
                  className="uploadCompany"
                  label={
                    <span>
                      {this.context.translate("_DESTINATION_")}<span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                  required={false}
                  rules={[
                    { required: true, message: this.context.translate("_DESTINATION_REQUIRED_"),},
                  ]}
                >
                  <Input readOnly={this.isReadOnly()} />
                </Form.Item>

                <Form.Item
                  name="destinationPartyName"
                  className="uploadCompany"
                  label={this.context.translate("_DESTINATION_PARTY_NAME_") + ":"}
                >
                  <Input readOnly={this.isReadOnly()} />
                </Form.Item>
                <Form.Item
                  name="checkInContactNo"
                  className="uploadCompany"
                 label={this.context.translate("_CHECK_IN_CONTACT_NO_") + ":"}
                >
                  <Input readOnly={this.isReadOnly()} />
                </Form.Item>

                <Form.Item
                  name="communicationMethod"
                  className="uploadCompany"
                   label={this.context.translate("_COMMUNICATION_METHOD_") + ":"}
                >
                  <Select disabled={this.isReadOnly()}>
                     <Option value="PhoneNo">
                      {this.context.translate("_PHONE_NO_")}
                    </Option>

                    <Option value="SMS">
                      {this.context.translate("_SMS_")}
                    </Option>

                    <Option value="Whatsapp">
                      {this.context.translate("_WHATSAPP_")}
                    </Option>
                  </Select>
                </Form.Item>
              </>
            )}

            {travelType === "Within Project" && (
              <>

                <Form.Item
                  name="proposedStartTime"
                  className="uploadCompany"
                  label={
                    <span>
                       {this.context.translate("_PROPOSED_START_TIME_")}<span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                     message: this.context.translate("_PROPOSED_START_TIME_REQUIRED_"),
                    },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();

                        if (value.isAfter(dayjs())) {
                          return Promise.resolve();
                        }

                        return Promise.reject(
                          new Error(this.context.translate("_PROPOSED_START_TIME_GREATER_CURRENT_"))
                        );
                      },
                    },
                  ]}
                >
                  <DatePicker
                    showTime
                    disabled={this.isReadOnly()}
                    style={{ width: "100%", height: "40px" }}
                    format={dateFormat}
                  />
                </Form.Item>

                <Form.Item
                  name="proposedEndTime"
                  className="uploadCompany"
                  dependencies={["proposedStartTime"]}
                  label={
                    <span>
                     {this.context.translate("_PROPOSED_END_TIME_")}<span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                       message: this.context.translate("_PROPOSED_END_TIME_REQUIRED_"),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startTime = getFieldValue("proposedStartTime");

                        if (!value) return Promise.resolve();

                        if (!value.isAfter(dayjs())) {
                          return Promise.reject(
                            new Error( this.context.translate("_PROPOSED_END_TIME_GREATER_START_"))
                          );
                        }

                        if (startTime && !value.isAfter(startTime)) {
                          return Promise.reject(
                            new Error(
                              this.context.translate("_PROPOSED_END_TIME_GREATER_START_")
                            )
                          );
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    disabled={this.isReadOnly()}
                    showTime
                    style={{ width: "100%", height: "40px" }}
                    format={dateFormat}
                  />
                </Form.Item>
              </>
            )}
             {this.props.getUserData().isadmin==6 &&
                 (<Form.Item
                  name="requestReturnDate"
                  className="uploadCompany"
                  label={
                    <span>
                          {this.context.translate("_REQUESTED_RETURN_DATE_")}
                        <span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                >
                 <Input readOnly/>
                </Form.Item>)}
                {this.props.getUserData().isadmin == 6 &&
                    (this.state.extendedDateTime !=null && this.state.extendedDateTime !=" ") && (
                      <Form.Item
                        name="extendedDateTime1"
                       label={this.context.translate("_EXTENDED_DATE_TIME_1_") + ":"}
                      >
                        <DatePicker
                          showTime
                          style={{ width: "100%", height: "40px" }}
                          format="DD-MM-YYYY hh:mm:ss"
                          disabled={this.isReadOnly()}
                        />
                      </Form.Item>
                  )}

                  {this.props.getUserData().isadmin == 6 &&
                     (this.state.extendedDateTime2 !=null && this.state.extendedDateTime2 !=" ") && (
                      <Form.Item
                        name="extendedDateTime2"
                       label={this.context.translate("_EXTENDED_DATE_TIME_2_") + ":"}
                      >
                        <DatePicker
                          showTime
                          style={{ width: "100%", height: "40px" }}
                          format="DD-MM-YYYY hh:mm:ss"
                          disabled={this.isReadOnly()}
                        />
                      </Form.Item>
                  )}

                  {this.props.getUserData().isadmin == 6 &&
                     (this.state.extendedDateTime3 !=null && this.state.extendedDateTime3 !=" ") && (
                      <Form.Item
                        name="extendedDateTime3"
                       label={this.context.translate("_EXTENDED_DATE_TIME_3_") + ":"}
                      >
                        <DatePicker
                          showTime
                          style={{ width: "100%", height: "40px" }}
                          format="DD-MM-YYYY hh:mm:ss"
                          disabled={this.isReadOnly()}
                        />
                      </Form.Item>
                  )}
          </Col>

          <Col span={12}>
            <Form.Item
              name="journeyDesk"
              className="uploadCompany"
              label={
                <span>
                   {this.context.translate("_JOURNEY_DESK_")}<span style={{ color: "red" }}>*</span>:
                </span>
              }
              required={false}
              rules={[{ required: true,  message: this.context.translate("_JOURNEY_DESK_REQUIRED_"), }]}
            >
              <Select placeholder={this.context.translate("_SELECT_JOURNEY_DESK_")} disabled={this.isReadOnly()}  labelInValue>
                {this.state.desks.map((d) => {
                  const value = d.id ?? d.deskId ?? d.value;
                  const label = d.name ?? d.deskName ?? d.label;
                  return (
                    <Option key={value} value={value}>
                      {label}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>

            <Form.Item
              name="journeyManager"
              className="uploadCompany"
              label={
                <span>
                  {this.context.translate("_JOURNEY_MANAGER_")}<span style={{ color: "red" }}>*</span>:
                </span>
              }
              required={false}
              rules={[
                { required: true, message: this.context.translate("_JOURNEY_MANAGER_REQUIRED_"), },
              ]}
            >
              <Select  placeholder={this.context.translate("_SELECT_JOURNEY_MANAGER_")} disabled={this.isReadOnly()}>
                {this.state.managers.map((m) => {
                  const value = m.id ?? m.userId ?? m.value;
                  const label = m.name ?? m.userName ?? m.label ?? (m.firstName ? `${m.firstName} ${m.lastName || ""}` : "");
                  return (
                    <Option key={value} value={value}>
                      {label}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            {this.state.riskScore >= 24 && (
              <Form.Item
                name="safetyIncharge"
                className="uploadCompany"
                label={
                  <span>
                     {this.context.translate("_SAFETY_MANAGER_")}<span style={{ color: "red" }}>*</span>:
                  </span>
                }
                required={false}
                rules={[
                  { required: true,  message: this.context.translate("_SAFETY_MANAGER_REQUIRED_"), },
                ]}
              >
                <Select
                  placeholder={this.context.translate("_SELECT_SAFETY_MANAGER_")}
                  disabled={this.state.isApprovedFromSafety === 1 || this.state.isApprovedFromSafety === 2 || this.isReadOnly()}

                >
                  {this.journeyPlannerStore.safetymanagerlist?.map((sm) => {
                    const value = sm.id
                    const label = sm.name
                    return (
                      <Option key={value} value={value}>
                        {label}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            )}
            {/* <Form.Item
              name="alternateApplicants"
              className="uploadCompany"
              label="Alternate Applicants:"
            >
              <Select />
            </Form.Item> */}
            <Form.Item
              name="applicantContactNo"
              className="uploadCompany"
              label={
                <span>
                      {this.context.translate("_APPLICANT_CONTACT_NUMBER_")}<span style={{ color: "red" }}>*</span>:
                </span>
              }
              required={false}
              rules={[
                { required: true,  message: this.context.translate("_APPLICANT_CONTACT_REQUIRED_"), },
              ]}
            >
              <Input placeholder={this.context.translate("_ENTER_CONTACT_NUMBER_")} readOnly />
            </Form.Item>

            <Form.Item
              name="travelType"
              className="uploadCompany"
              label={
                <span>
                   {this.context.translate("_TRAVEL_TYPE_")}<span style={{ color: "red" }}>*</span>:
                </span>
              }
              required={false}
              rules={[{ required: true, message: this.context.translate("_TRAVEL_TYPE_REQUIRED_"), }]}
            >
              <Select
                disabled={this.isReadOnly()}
                onChange={(val) => {
                  const updates = {
                    travelType: val,
                    activeTab: "1",
                  };
                  if (!this.isEditMode()) {
                    updates.riskSelections = {};
                    updates.riskScore = 0;
                  }
                  this.setState(updates);
                  if (!this.isEditMode()) {
                    this.formRef.current?.setFieldsValue({ riskScore: 0 });
                  }
                }}
              >
                <Option value="Outside Project">   {this.context.translate("_OUTSIDE_PROJECT_")}</Option>
                <Option value="Within Project"> {this.context.translate("_WITHIN_PROJECT_")}</Option>
              </Select>
            </Form.Item>
            {travelType === "Within Project" && (
              <>

                <Form.Item
                  name="coPassengers"
                  className="uploadCompany"
                  label={
                    <span>
                      {this.context.translate("_CO_PASSENGERS_")}
                      <span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                  required={false}
                  rules={[
                    { required: true, message: this.context.translate("_CO_PASSENGERS_REQUIRED_"), },
                  ]}
                >
                  <Input readOnly={this.isReadOnly()} />
                </Form.Item>
                <Form.Item
                  name="purpose"
                  className="uploadCompany"
                  label={this.context.translate("_PURPOSE_") + ":"}
                >
                  <Input.TextArea rows={3} readOnly={this.isReadOnly()} />
                </Form.Item>
              </>
            )}


            {travelType === "Outside Project" && (
              <>
                <Form.Item
                  name="purpose"
                  className="uploadCompany"
                  label={this.context.translate("_PURPOSE_") + ":"}
                >
                  <Select disabled={this.isReadOnly()}>
                     <Option value="Site Visit">
                      {this.context.translate("_SITE_VISIT_")}
                    </Option>

                    <Option value="Meeting">
                      {this.context.translate("_MEETING_")}
                    </Option>

                    <Option value="Works">
                      {this.context.translate("_WORKS_")}
                    </Option>

                    <Option value="Others">
                      {this.context.translate("_OTHERS_")}
                    </Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="destinationContact"
                  className="uploadCompany"
                  label={this.context.translate("_DESTINATION_CONTACT_") + ":"}
                >
                  <Input readOnly={this.isReadOnly()} />
                </Form.Item>

                <Form.Item
                  name="proposedStartTime"
                  label={
                    <span>
                      {this.context.translate("_PROPOSED_TRAVEL_DATE_")}
                      <span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: this.context.translate("_PROPOSED_TRAVEL_DATE_REQUIRED_"),
                    },
                  ]}
                >
                  <DatePicker
                    disabled={this.isReadOnly()}
                    showTime={{
                      disabledTime: this.disablePastTime,
                    }}
                    disabledDate={this.disablePastDate}

                    style={{ width: "100%", height: "40px" }}
                    format={dateFormat}
                  />
                </Form.Item>
                <Form.Item
                  name="proposedEndTime"
                  dependencies={["proposedStartTime"]}
                  label={
                    <span>
                       {this.context.translate("_EXPECTED_ARRIVAL_DATE_")}
                      <span style={{ color: "red" }}>*</span>:
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: this.context.translate("_EXPECTED_ARRIVAL_DATE_REQUIRED_"),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startTime = getFieldValue("proposedStartTime");

                        if (!value || !startTime) {
                          return Promise.resolve();
                        }

                        if (value.isAfter(startTime)) {
                          return Promise.resolve();
                        }

                        return Promise.reject(
                          new Error(
                            this.context.translate(
                              "_EXPECTED_ARRIVAL_AFTER_PROPOSED_"
                            )
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    disabled={this.isReadOnly()}
                    showTime={{
                      disabledTime: this.disablePastTime,
                    }}
                    disabledDate={this.disablePastDate}

                    style={{ width: "100%", height: "40px" }}
                    format={dateFormat}
                  />
                </Form.Item>

                <Form.Item
                  name="route"
                  className="uploadCompany"
                   label={this.context.translate("_ROUTE_") + ":"}
                >
                  <Input readOnly={this.isReadOnly()} />
                </Form.Item>

                <Form.Item
                  name="riskScore"
                  className="uploadCompany"
                   label={this.context.translate("_RISK_SCORE_") + ":"}
                >
                  <Input readOnly style={{ backgroundColor: "#f5f5f5" }} />
                </Form.Item>
              </>
            )}
          </Col>
        </Row>

        {this.isEditMode() && (this.state.safetyRejectionReason || this.state.reasonForRejection) && (
          <Row gutter={16} style={{ marginTop: "10px" }}>
            {this.state.safetyRejectionReason && (
              <Col span={12}>
                <Form.Item
                  name="safetyRejectionReason"
                  className="uploadCompany"
                 label={this.context.translate("_REASON_FOR_REJECTION_")}
                >
                  <Input.TextArea rows={3} disabled style={{ backgroundColor: "#f5f5f5", color: "#000" }} />
                </Form.Item>
              </Col>
            )}
            {/* {this.state.reasonForRejection && (
              <Col span={12}>
                <Form.Item
                  name="reasonForRejection"
                  className="uploadCompany"
                  label="Rejection Reason:"
                >
                  <Input.TextArea rows={3} disabled style={{ backgroundColor: "#f5f5f5", color: "#000" }} />
                </Form.Item>
              </Col>
            )} */}
          </Row>
        )}

        {/* For non-admin 6/7: show readonly vehicle or rejection reason based on journey status */}
        {this.isEditMode() && (() => {
          const adminType = Number(this.props.getUserData().isadmin);
          if (adminType === 6 || adminType === 7) return null;
          const { approvalAction, vehiclesList, reasonForRejection } = this.state;

          if (approvalAction === "accept") {
            return (
              <Row gutter={16} style={{ marginTop: "10px" }}>
                <Col span={12}>
                  <Form.Item
                    name="vehicleId"
                    className="uploadCompany"
                    label={this.context.translate("_SELECTED_VEHICLE_") + ":"}
                  >
                    <Select disabled style={{ backgroundColor: "#f5f5f5" }}>
                      {vehiclesList?.map((v) => (
                        <Option key={v.vehicleId} value={v.vehicleId}>
                          {v.vehicleNo}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            );
          }

          if (approvalAction === "reject") {
            return (
              <Row gutter={16} style={{ marginTop: "10px" }}>
                <Col span={12}>
                  <Form.Item
                    name="reasonForRejection"
                    className="uploadCompany"
                   label={this.context.translate("_REASON_FOR_REJECTION_") + ":"}
                  >
                    <Input.TextArea
                      rows={3}
                      readOnly
                      style={{ backgroundColor: "#f5f5f5", color: "#000" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            );
          }

          return null;
        })()}

        {this.renderApprovalSection()}
      </div>
    );
  }

  renderTab2() {
    const { riskSelections, travelType } = this.state;
    const riskMatrixReadOnly = this.isEditMode();
     const translatedRows = getTranslatedRiskMatrixRows(this.context.translate.bind(this.context));
    return (
      <div style={{ overflowY: "scroll", height: "90%", padding: "10px 20px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {translatedRows.map((row) => (
              <tr key={row.key}>
                <td
                  style={{
                    width: "18%",
                    // fontWeight: "bold",
                    fontSize: 14,
                    textAlign: "left",
                    paddingRight: 12,
                    paddingTop: 10,
                    paddingBottom: 10,
                    verticalAlign: "middle",
                    whiteSpace: "nowrap",
                  }}
                >
                  {row.label}
                  {travelType === "Outside Project" && !riskMatrixReadOnly && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                  :
                </td>
                {row.options.map((opt) => (
                  <td
                    key={opt.label}
                    style={{
                      backgroundColor: opt.color,
                      padding: "6px 10px",
                      cursor: riskMatrixReadOnly ? "not-allowed" : "pointer",
                      width: "27%",
                      opacity: riskMatrixReadOnly ? 0.85 : 1,
                    }}
                    onClick={
                      riskMatrixReadOnly
                        ? undefined
                        : () => this.handleRiskSelect(row.key, opt.score)
                    }
                  >
                    <span
                      style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                      <Checkbox
                        checked={riskSelections[row.key] === opt.score}
                        disabled={riskMatrixReadOnly}
                        onChange={() =>
                          this.handleRiskSelect(row.key, opt.score)
                        }
                        style={{ pointerEvents: "none" }}
                      />
                      <span style={{ fontSize: 12, color: "#000" }}>
                        {opt.label}
                      </span>
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* <Row style={{ marginTop: 20 }}>
          <Col span={8} offset={8}>
            <Form.Item name="riskScore" label="Risk Score:">
              <Input readOnly style={{ backgroundColor: "#f5f5f5" }} />
            </Form.Item>
          </Col>
        </Row> */}
      </div>
    );
  }

  render() {
    const { activeTab, travelType, isAlreadyRejected, isApprovedFromSafety } = this.state;
    const showRiskTab = travelType === "Outside Project";
    // Disable submit when journey is rejected (by desk manager or safety manager)
    const isJourneyRejected = isAlreadyRejected || Number(isApprovedFromSafety) === 2;

    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              ref={this.formRef}
              layout="vertical"
              name="journey-planner-form"
              onFinish={this.onSubmit}
              className="accountFormClass"
            >
              <div style={{ height: "100%" }}>
                {/* Dark header — same as VehicleAdd2 */}
                <div
                  style={{
                    background: "#07163D",
                    padding: "15px",
                    height: "10%",
                  }}
                >
                  <h3 className="tab-title">{this.showTabTitle()}</h3>
                  <p className="tab-description">{this.showTabDesc()}</p>
                </div>

                <Tabs
                  className="accountTabs"
                  style={{ height: "90%" }}
                  activeKey={activeTab}
                  onChange={this.handleTabChange}
                >
                  {/* Tab 1 — Journey Details */}
                  <TabPane
                    key="1"
                    tab={
                      <Button
                        type="text"
                        style={{
                          background:
                            activeTab === "1"
                              ? "rgba(255,255,255,0.30)"
                              : "rgb(7,22,61)",
                          border: "none",
                          borderRadius: "0px",
                        }}
                      >
                        {this.context.translate("_JOURNEY_DETAILS_")}
                      </Button>
                    }
                  >
                    {this.renderTab1()}

                    <div className="formFooter">
                      <Button
                        className="formsCancelButton"
                        style={{ marginInlineEnd: "10px" }}
                        onClick={() => {
                          this.closeModal();
                        }}
                      >
                        {this.context.translate("_FLEET_CLOSE_BTN_")}
                      </Button>
                      {showRiskTab ? (
                        <Button
                          className="formsSaveButton"
                          onClick={() => {
                            this.handleNextClick();
                          }}
                        >
                          {this.context.translate("_NEXT_") || "Next"}
                        </Button>
                      ) : (
                        <Button
                          htmlType="submit"
                          className="formsSaveButton"
                          disabled={isJourneyRejected}
                        >
                          {this.context.translate("_SUBMIT_")}
                        </Button>
                      )}
                    </div>
                  </TabPane>

                  {/* Tab 2 — Risk Matrix (only for Outside Project) */}
                  {showRiskTab && (
                    <TabPane
                      key="2"
                      tab={
                        <Button
                          type="text"
                          style={{
                            background:
                              activeTab === "2"
                                ? "rgba(255,255,255,0.30)"
                                : "rgb(7,22,61)",
                            border: "none",
                            borderRadius: "0px",
                          }}
                        >
                        {this.context.translate("_RISK_MATRIX_")} <span style={{ color: "red" }}>*</span>
                        </Button>
                      }
                    >
                      {this.renderTab2()}

                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          style={{ marginInlineEnd: "10px" }}
                          onClick={() => {
                            this.closeModal();
                          }}
                        >
                          {this.context.translate("_FLEET_CLOSE_BTN_")}
                        </Button>
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.handleBackClick();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_",
                          )}
                        </Button>
                        <Button
                          htmlType="submit"
                          className="formsSaveButton"
                          disabled={isJourneyRejected}
                        >
                          {this.context.translate("_SUBMIT_")}
                        </Button>
                      </div>
                    </TabPane>
                  )}
                </Tabs>
              </div>
            </Form>
          </Spin>

          {this.state.showApprovalAlert && (
            <Modal
              maskClosable={false}
              title={
                <div className="confirmStatusTitle">
                  <span>Alert</span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ showApprovalAlert: false })}
                  />
                </div>
              }
              className="update-statusModal"
              centered
              open={this.state.showApprovalAlert}
              footer={null}
              width={350}
              closable={false}
            >
              <div className="confirmStatusText">
                <p>
                  Please <span style={{ color: "#52c41a", fontWeight: "bold" }}>Approve</span>{" "}
                  or{" "}
                  <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>Reject</span> Trip
                </p>
              </div>
              <div className="confirmStatusButtons">
                <Button
                  className="confirmStatusOkButton"
                  onClick={() => this.setState({ showApprovalAlert: false })}
                >
                  OK
                </Button>
              </div>
            </Modal>
          )}
        </div>
      </div>
    );
  }
}

JourneyPlannerAdd.contextType = StoreContext;
export default observer(withRouter(JourneyPlannerAdd));
